import { reactive } from 'vue'

// Global state - shared across all components
const state = reactive({
    isVisible: false,
    dialogOptions: {
        title: 'Potwierdzenie',
        message: 'Czy na pewno chcesz kontynuować?',
        confirmText: 'Tak',
        cancelText: 'Anuluj',
        danger: false
    }
})

let resolvePromise = null

export function useConfirmDialog() {
    const showConfirm = (options = {}) => {
        state.dialogOptions = {
            title: options.title || 'Potwierdzenie',
            message: options.message || 'Czy na pewno chcesz kontynuować?',
            confirmText: options.confirmText || 'Tak',
            cancelText: options.cancelText || 'Anuluj',
            danger: options.danger || false
        }

        state.isVisible = true

        return new Promise((resolve) => {
            resolvePromise = resolve
        })
    }

    const handleConfirm = () => {
        state.isVisible = false
        if (resolvePromise) {
            resolvePromise(true)
            resolvePromise = null
        }
    }

    const handleCancel = () => {
        state.isVisible = false
        if (resolvePromise) {
            resolvePromise(false)
            resolvePromise = null
        }
    }

    const handleClose = () => {
        state.isVisible = false
        if (resolvePromise) {
            resolvePromise(false)
            resolvePromise = null
        }
    }

    return {
        state,
        showConfirm,
        handleConfirm,
        handleCancel,
        handleClose
    }
}
